import Vue from 'vue';
import { expandFilterValue, FilterObject } from '../../../services/map/filter';

export const mutations = {
    SET_FILTER(state, { layerId, filter: filterObject }) {
        const filterId = filterObject.filterId;
        const layer = state.layers.find(_layer => _layer.id === layerId);
        if (!layer) {
            throw new Error(`The layer ${layerId} could not be found`);
        }
        if (layer.type !== 'theme') {
            throw new Error('filters can only be set on theme layers');
        }
        const filtersObject = layer.filters.settings;
        const activeFilters = filtersObject.filter(({ data }) => data.filterId !== filterId);
        if (filterObject && filterObject.filter.selected) {
            activeFilters.push(
                {
                    data: filterObject,
                    filter: FilterObject.AttributeFilterObject({
                        caseSensitive: filterObject.filter.caseSensitive,
                        filterAttribute: filterObject.filter.filterAttribute,
                        operator: filterObject.filter.operator,
                        value: expandFilterValue(filterObject.filter.value),
                        visible: filterObject.filter.visible,
                        dataType: filterObject.filter.dataType,
                        omitCase: filterObject.filter.omitCase
                    })
                }
            );
        }
        layer.filters.settings = activeFilters;
    },
    CLEAR_FILTER(state, { layerId }) {
        const layer = state.layers.find(_layer => _layer.id === layerId);
        if (!layer) {
            throw new Error(`The layer ${layerId} could not be found`);
        }
        if ( layer.filters) {
            layer.filters.settings = [];
        }
    },
    SET_DEFAULT_FILTERS(state, { filters }) {
        Vue.set(state, 'defaultFilters', filters);
    }
};
